/* eslint-disable @typescript-eslint/no-empty-function */
import { CloseIcon } from 'assets/icons/CloseIcon'
import { DashboardCard, P } from 'styling/GlobalStyles'
import { IWidget } from 'types/dashboard.interface'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { WidgetHeader, WidgetTitle } from './widgetParts.styled'
import { WidgetBody } from '../hrLayout.styled'
import { HrWidgetBody } from './HrWidgetBody'

export const HrTransportationWidget = ({ modalOpen, removeWidget, onDragOver, onDragStart, onDragDrop }: IWidget) => {
  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => onDragStart('transportation', 1)}
      onDrop={onDragDrop}
      onDragEnd={(e) => e.preventDefault()}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('transportation')
      }}
      width='1fr'
      style={{ gridArea: 'transportation', cursor: modalOpen ? 'grab' : 'normal' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('transportation')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon />
        </WidgetEditOverlay>
      )}
      <WidgetHeader>
        <WidgetTitle>Transportation</WidgetTitle>
      </WidgetHeader>
      <WidgetBody>
        <HrWidgetBody type='transport' />
      </WidgetBody>
    </DashboardCard>
  )
}
